<div class="skeleton-promo-banners-container">
  <div class="skeleton-promo-banners__banner"></div>
  <div class="skeleton-promo-banners__banner"></div>
  <div class="skeleton-promo-banners__banner"></div>
  <div class="skeleton-promo-banners__banner"></div>
</div>
